import Button from '@rio-cloud/rio-uikit/Button';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';
import Dialog from '@rio-cloud/rio-uikit/Dialog';
import { FunctionComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { useAppDispatch, useAppSelector } from '../../../../../configuration/setup/hooks';
import {
    BulkStatusUpdateStep,
    compoundManagementSlice,
    getBulkStatusUpdateErrorCode,
    getBulkStatusUpdateStep,
    getLoadPreview,
} from '../../../reducers/compoundManagementSlice';
import { BulkStatusUpdateDialogBody } from './BulkStatusUpdateDialogBody';
import { useBulkStatusUpdateForm } from './useBulkStatusUpdateForm';

export const MAX_BULK_SIZE = 5_000;

export const BulkStatusUpdateDialog: FunctionComponent = () => {
    const dispatch = useAppDispatch();
    const currentStep = useAppSelector(getBulkStatusUpdateStep);
    const errorCode = useAppSelector(getBulkStatusUpdateErrorCode);
    const loadPreview = useAppSelector(getLoadPreview);

    const showDialog = currentStep !== BulkStatusUpdateStep.BULK_SELECTION;
    const hasNextStep = currentStep !== BulkStatusUpdateStep.FORM;
    const nextButtonDisabled =
        errorCode !== undefined ||
        (currentStep === BulkStatusUpdateStep.REVIEW_TABLE &&
            (loadPreview === undefined || loadPreview.vehicles.length === 0));

    const { submitBulkStatusCompletion, isProcessing, resetFormState, ...form } = useBulkStatusUpdateForm(loadPreview);

    const handleClose = () => {
        resetFormState();
        dispatch(compoundManagementSlice.actions.abortBulkStatusUpdate());
    };
    const handleNext = () => {
        dispatch(compoundManagementSlice.actions.nextBulkStatusUpdateStep());
    };

    return (
        <Dialog show={showDialog} onClose={handleClose} showCloseButton bsSize={Dialog.SIZE_LG}>
            <Dialog.Title
                title={<FormattedMessage id="outboundOrderBook.compoundManagement.bulkStatusUpdate.dialogTitle" />}
            />
            <Dialog.Body>
                <BulkStatusUpdateDialogBody currentStep={currentStep} isProcessing={isProcessing} formProps={form} />
            </Dialog.Body>
            <Dialog.Footer>
                <ButtonToolbar>
                    <Button
                        onClick={handleClose}
                        className={isProcessing ? 'btn-loading disabled' : ''}
                        disabled={isProcessing}
                    >
                        <FormattedMessage id="outboundOrderBook.common.button.cancel" />
                    </Button>
                    {hasNextStep ? (
                        <Button bsStyle={Button.PRIMARY} onClick={handleNext} disabled={nextButtonDisabled}>
                            <FormattedMessage id="outboundOrderBook.common.button.next" />
                        </Button>
                    ) : (
                        <Button
                            bsStyle={Button.PRIMARY}
                            className={isProcessing ? 'btn-loading disabled' : ''}
                            onClick={submitBulkStatusCompletion}
                            disabled={isProcessing}
                        >
                            <FormattedMessage id="outboundOrderBook.compoundManagement.bulkStatusUpdate.createLoad" />
                        </Button>
                    )}
                </ButtonToolbar>
            </Dialog.Footer>
        </Dialog>
    );
};
